import { createRouter, createWebHashHistory } from 'vue-router';
import Top from '@/components/Top.vue';
import LoginError from '@/components/LoginError.vue';
import Agree from '@/components/Agree.vue';
import ContractForm from '@/components/ContractForm.vue';
import SetupEmoForm from '@/components/SetupEmoForm.vue';
import ContractConfirm from '@/components/ContractConfirm.vue';
import Payment from "@/components/Payment.vue";
import ContractComplete from '@/components/ContractComplete.vue';
// import InvalidAccess from '@/components/InvalidAccess.vue';

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/top',
            name: 'Top',
            component: Top,
            meta: {
                title: 'サイトTOP'
            }
        },
        {
            path: '/loginerror',
            name: 'LoginError',
            component: LoginError,
            meta: {
                title: 'このアカウントではこちらのページをご使用になれません'
            }
        },
        {
            path: '/agree',
            name: 'Agree',
            component: Agree,
            meta: {
                title: '規約確認'
            }
        },
        {
            path: '/contractForm',
            name: 'ContractForm',
            component: ContractForm,
            meta: {
                title: '会員情報の入力'
            }
        },
        {
            path: '/setupEmoForm',
            name: 'SetupEmoForm',
            component: SetupEmoForm,
            meta: {
                title: 'emo設定情報入力'
            }
        },
        {
            path: '/contractConfirm',
            name: 'ContractConfirm',
            component: ContractConfirm,
            meta: {
                title: '入力情報の確認'
            }
        },
        {
            path: '/payment',
            name: 'Payment',
            component: Payment,
            meta: {
                title: '支払い方法の入力'
            }
        },
        {
            path: '/contractComplete',
            name: 'ContractComplete',
            component: ContractComplete,
            meta: {
                title: 'お申込み完了'
            }
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'Top',
            component: Top,
            meta: {
                title: 'サイトTOP'
            }
        }

        // {
        //     path: '/invalidAccess',
        //     name: 'InvalidAccess',
        //     component: InvalidAccess,
        //     meta: {
        //         title: '不正なアクセスです'
        //     }
        // },
    ],
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else {
            // 画面遷移時にスクロールを一番上に移動
            return { top: 0, left: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
//     // 画面を離脱するときにダイアログを出す対応。
//     // 【制限事項】
//     // IE以外はブラウザ標準メッセージしかでない（でもポータルはIEは未対応）。
//     // iOSではダイアログがでない（イベントに対応していない）
//     // 画面操作をしていないとイベントが発火しない。
//     window.onbeforeunload = null;
//     document.needBeforeunload = true;
//     if (!['InvalidAccess', 'ContractComplete'].includes(to.name)) {
//         window.onbeforeunload = function(e) {
//             if (!document.needBeforeunload) {
//                 return;
//             }
//             const msg = "まだお申し込みは完了していません。\nこれまでの操作は保存されず、最初からやり直して頂く必要があります。\nこのページから移動してもよろしいですか？";
//             e.returnValue = msg;
//             return msg;
//         }
//     }

//     // 再読み込みの場合はエラーとする
//     // ドキュメントとしてはSafariは動作しないとなっていたが、動作上navigation.typeがないと動かないため
//     if (!process.env.VUE_APP_RELOADABLE) {
//         const entries = performance && performance.getEntriesByType('navigation');
//         const naviType = window && window.performance && window.performance.navigation && window.performance.navigation.type;
//         if ((entries && entries[0] && entries[0].type === 'reload') || naviType && naviType === 1) {
//             if (['InvalidAccess'].includes(to.name)) {
//                 next();
//                 return;
//             }

//             next({
//                 name: 'InvalidAccess'
//             });
//             return;
//         }
//     }

    // IDトークンを持たない場合
    if (!document.idToken) {
        // ブラックリストユーザーの場合はLoginError画面に遷移させる
        if (document.isBlackList) {
            if (to.name === 'LoginError') {
                next();
                return;
            }
            next({ name: 'LoginError' });
            return;
        }

        // 未ログインで表示する画面の場合はそのまま
        if (['Top', 'Flow', 'LoginError'].includes(to.name)) {
            next();
            return;
        }

        // 上記以外の場合、TOP画面に移動させる
        next({
            name: 'Top'
        });
        return;
    }

    // IDトークンを持ち、最初に開かれた場合
    if (!from.name) {
        // サービス内容の提示画面の場合はそのまま
        if (['Agree'].includes(to.name)) {
            next();
            return;
        }

        // サービス内容の提示画面に移動させる
        next({
            name: 'Agree'
        });
        return;
    }

    // 上記以外の場合、要求された画面を表示
    next();
});

// Google Analyticsでのトラッキング用
router.afterEach((to, from) => { // eslint-disable-line no-unused-vars
    // gtag関数が見つからなかった場合はスキップする
    if (typeof gtag !== 'function') { // eslint-disable-line no-undef
        return;
    }

    gtag("set", "linker", { domains: JSON.stringify(["necolico.co.jp", location.hostname]) }); // eslint-disable-line no-undef
    gtag('event', 'page_view', { // eslint-disable-line no-undef
        page_title: to.meta && to.meta.title,
        page_location: "https://" + location.hostname + '/bocco/rental' + (to.path === '/' ? '/top' : to.path)
    });
});

export default router;
